import styled from "styled-components";

export const StylesRootContainer = styled.div`
  isolation: isolate;
  --main-color: #0076ff;
  --size: 2rem;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 90vw;
  margin: 2rem 1.25rem;
  z-index: 9999;

  @media screen and (min-width: 30em) {
    width: 94vw;
  }

  @media screen and (min-width: 48em) {
    margin: 2rem 1.5rem;
    width: auto;
  }
`;
